var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPrivacyPolicyEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 46,
    rx: 23,
    fill: "#1570EF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.7139 14.4287C24.1083 14.4287 24.4285 14.7482 24.4287 15.1426C24.4287 15.5371 24.1084 15.8574 23.7139 15.8574H15.1426C14.7483 15.8576 14.4289 16.177 14.4287 16.5713V30.8574C14.4287 31.2519 14.7482 31.5721 15.1426 31.5723H28C28.3944 31.5721 28.7139 31.2518 28.7139 30.8574V23.7148C28.7139 23.3203 29.0342 23 29.4287 23C29.823 23.0002 30.1426 23.3205 30.1426 23.7148V30.8574C30.1426 32.0408 29.1833 33.0008 28 33.001H15.1426C13.9592 33.0008 13 32.0408 13 30.8574V16.5713C13.0001 15.388 13.9593 14.4288 15.1426 14.4287H23.7139ZM30.2656 13C30.9908 12.9999 31.6864 13.288 32.1992 13.8008C33.2669 14.8687 33.2671 16.6002 32.1992 17.668L22.791 27.0771C22.7127 27.1556 22.6169 27.2149 22.5117 27.25L18.2256 28.6787C18.1529 28.7026 18.0765 28.7147 18 28.7148C17.9236 28.7147 17.8479 28.7019 17.7754 28.6777C17.4011 28.5531 17.1986 28.1487 17.3232 27.7744L18.752 23.4893C18.7871 23.3843 18.8459 23.2886 18.9238 23.21L28.332 13.8018C28.8434 13.2869 29.5399 12.9979 30.2656 13Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrivacyPolicyEdit);
export default __webpack_public_path__ + "static/media/privacyPolicyEdit.16d56bdb61c36336d1af3581ae45dec6.svg";
export { ForwardRef as ReactComponent };